import(/* webpackMode: "eager" */ "/app/hub/src/app/iframe/[accountId]/folder/[folderId]/entry/[entryId]/error.tsx");
